import AxiosInstance from "../axiosInstance"; 


export const getStateList = async () => {
    const cached = localStorage.getItem("stateList");
  
    if (cached) {
      try {
        const storedList = JSON.parse(cached);
        if (storedList.length > 0) {
          return storedList;
        }
      } catch (e) {
        console.error("Error parsing stateList from localStorage", e);
      }
    }
  
    const transformData = (items) =>
      items
        .map(({ id, name }) => ({
          value: id,
          label: name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
  
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_STATE_API}`
      );
      const data = response.data?.data || [];
      const transformed = transformData(data);
      localStorage.setItem("stateList", JSON.stringify(transformed));
      return transformed;
    } catch (error) {
      console.error("Failed to fetch states:", error?.message);
      return [];
    }
  };